export const types = {
  SET_FOLDERS: 'SET_FOLDERS',
  ADD_FOLDER: 'ADD_FOLDER',
  UPDATE_FOLDER: 'UPDATE_FOLDER',
  REMOVE_FOLDER: 'REMOVE_FOLDER',
  SET_UI_FLAG: 'SET_UI_FLAG',
};

export default {
  [types.SET_FOLDERS](state, folders) {
    state.folders = folders;
  },
  [types.ADD_FOLDER](state, folder) {
    state.folders.push(folder);
  },
  [types.UPDATE_FOLDER](state, updated) {
    const idx = state.folders.findIndex(f => f.id === updated.id);
    if (idx !== -1) state.folders.splice(idx, 1, updated);
  },
  [types.REMOVE_FOLDER](state, id) {
    state.folders = state.folders.filter(f => f.id !== id);
  },
  [types.SET_UI_FLAG](state, flags) {
    state.uiFlags = { ...state.uiFlags, ...flags };
  },
};
